'use client';

import { cn } from '@bells/core/lib/utils';
import { Button } from '@bells/ui/components/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@bells/ui/components/tooltip';
import { IconBrandSignal } from '@bells/ui/icons/signal';
import { Telegram } from '@bells/ui/icons/telegram';
import { Mail } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useLCP } from 'node_modules/@bells/ui/src/utils/use-lcp';
import { useEffect, useState } from 'react';

export default function BottomIcons({}: Readonly<{}>) {
  const [afterLcp, setAfterLcp] = useState(false);
  useLCP(() => {
    setAfterLcp(true);
  });

  const pathName = usePathname();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (afterLcp) {
      const checkTrigger = () => {
        const scrolled = window.scrollY > window.innerHeight - 0;
        const shortPage = document.body.scrollHeight <= window.innerHeight;
        setShow(scrolled || shortPage);
      };

      checkTrigger();

      window.addEventListener('scroll', checkTrigger, { passive: true });
      window.addEventListener('resize', checkTrigger);

      return () => {
        window.removeEventListener('scroll', checkTrigger);
        window.removeEventListener('resize', checkTrigger);
      };
    }
  }, [afterLcp]);

  return (
    <div
      className={cn(
        'fixed bottom-5 right-5 z-[10] flex flex-col gap-2 opacity-100 transition-all duration-200',
        !afterLcp || !show || pathName.includes('/settings')
          ? 'select-none opacity-0'
          : ''
      )}
    >
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            asChild
            variant={'telegram'}
            size={'icon'}
            className='rounded-lg [&_svg]:size-5'
          >
            <Link href={'https://t.me/bbescort'} target='_blank'>
              <Telegram></Telegram>
              <span className='sr-only'>Chat with us on Telegram</span>
            </Link>
          </Button>
        </TooltipTrigger>
        <TooltipContent align='start'>Chat with us on Telegram</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            asChild
            variant={'signal'}
            size={'icon'}
            className='rounded-lg [&_svg]:size-5'
          >
            <Link
              href={
                'https://signal.me/#eu/JAGRgW9JF-FyutDBi50L5eReo8lsf15z5-ojQxvZocq58H4j8UdDzIH9CNXKwHHk'
              }
              target='_blank'
            >
              <IconBrandSignal></IconBrandSignal>
              <span className='sr-only'>Chat with us on Signal</span>
            </Link>
          </Button>
        </TooltipTrigger>
        <TooltipContent align='start'>Chat with us on Signal</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            asChild
            variant={'mail'}
            size={'icon'}
            className='rounded-lg [&_svg]:size-5'
          >
            <Link href={'mailto:info@skypleasureltd.com'} target='_blank'>
              <Mail></Mail>
              <span className='sr-only'>Send us on email</span>
            </Link>
          </Button>
        </TooltipTrigger>
        <TooltipContent align='start'>Send us on email</TooltipContent>
      </Tooltip>
    </div>
  );
}
